import React from 'react';
import cn from 'classnames';
import styles from './index.module.css';

const Checkbox = ({
  wrapperClassName,
  className,
  label,
  input,
  input: { name },
}) => (
  <div className={cn(styles.checkbox, wrapperClassName)}>
    <input className={className} {...input} type="checkbox" id={name} checked={input.value} />
    <label htmlFor={name}>{label}</label>
  </div>
);

export default Checkbox;
